import { Schema } from "effect";
export const LatestResumeDate = Schema.Struct({
    date: Schema.NullOr(Schema.Date),
});
